import { render } from "./DoubleChevronUpIcon.vue?vue&type=template&id=3dcf7a43"
const script = {}
script.render = render

export default script